import React, { useEffect, useState } from 'react'
import { IconButton, Box } from '@material-ui/core'
import { Add as AddIcon } from '@material-ui/icons'
import * as Styled from './ChatComposerActions.styles'

interface ChatComposerActionsProps {
  containerRef: React.RefObject<HTMLElement>
  hasMessages: boolean
  disabled?: boolean
  label: string
  children: React.ReactNode
}

const ChatComposerActions: React.FC<ChatComposerActionsProps> = ({
  containerRef,
  hasMessages,
  disabled,
  label,
  children
}) => {
  const [isOpen, setIsOpen] = useState(false)

  const handleOpen = () => setIsOpen(true)
  const handleClose = () => setIsOpen(false)

  useEffect(() => {
    if (disabled) setIsOpen(false)
  }, [disabled])

  const anchorEl = containerRef.current

  return (
    <Box>
      <IconButton aria-label={label} size='small' onClick={handleOpen} disabled={disabled}>
        <AddIcon />
      </IconButton>
      <Styled.ActionsMenu
        anchorEl={anchorEl}
        open={isOpen && Boolean(anchorEl)}
        onClose={handleClose}
        getContentAnchorEl={null}
        anchorOrigin={{ vertical: hasMessages ? 'top' : 'bottom', horizontal: 'left' }}
        transformOrigin={{ vertical: hasMessages ? 'bottom' : 'top', horizontal: 'left' }}
        PaperProps={{ elevation: 0, variant: 'outlined' }}
        $width={anchorEl?.clientWidth}
        $opensUpward={hasMessages}
        onClick={handleClose}
      >
        {children}
      </Styled.ActionsMenu>
    </Box>
  )
}

export { ChatComposerActions }
